export let routers = ['HomeworkAnalysis','CouserwareAnalysis','AllActiveSch','RegionalQuestion']